import { INACTIVE_IN_COMPETITOR_STATUS } from './pendentesConstants';

export function rootUrl(value) {
  try {
    const url = new URL(value);
    return `${url.protocol}//${url.host}`;
  } catch {
    return String(value || '')
      .split('/')
      .slice(0, 3)
      .join('/');
  }
}

export function inactiveSourceLinkTitle(link) {
  const root = link?.root || rootUrl(link?.sourceUrl || link?.url || '');
  return [root, 'anúncio inativo no concorrente'].filter(Boolean).join(' - ');
}

export function isInactiveInCompetitorItem(item) {
  return item?.status === INACTIVE_IN_COMPETITOR_STATUS;
}

export function inactiveFallbackSourceLink(item) {
  if (!isInactiveInCompetitorItem(item) || !item?.sourceUrl) return null;
  const root = rootUrl(item.sourceUrl);
  return {
    key: 'inactive-sourceUrl',
    label: 'Abrir',
    icon: 'i-lucide-circle-off',
    url: item.sourceUrl,
    root,
    inactive: true,
    title: inactiveSourceLinkTitle({ root, sourceUrl: item.sourceUrl }),
  };
}

export function normalizeSourceLink(link, index, item = null) {
  const url = link?.url || link?.sourceUrl || '';
  const inactiveHint = [link?.status, link?.title, link?.inactiveTooltip]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  const inactive =
    isInactiveInCompetitorItem(item) ||
    link?.inactive === true ||
    link?.isActive === false ||
    link?.is_active === false ||
    inactiveHint.includes('inativo') ||
    inactiveHint.includes('inactive') ||
    inactiveHint.includes('desativado') ||
    inactiveHint.includes('removed');
  const root = link?.root || link?.rootUrl || rootUrl(url);
  return {
    key:
      link?.key ||
      [link?.sourceKind || 'source', link?.sourceListingId || index, url].join(
        ':'
      ),
    label: link?.label || 'Abrir',
    icon:
      link?.icon ||
      (inactive ? 'i-lucide-circle-off' : 'i-lucide-external-link'),
    url,
    root,
    inactive,
    title: inactive
      ? inactiveSourceLinkTitle({ ...link, root, sourceUrl: url })
      : link?.title || link?.sourcePortal || 'Abrir anúncio no concorrente',
  };
}

export function itemSourceLinks(item) {
  if (!item) return [];
  if (Array.isArray(item.sourceLinksDisplay)) {
    if (item.sourceLinksDisplay.length) {
      return item.sourceLinksDisplay
        .filter(link => link?.url || link?.sourceUrl)
        .map((link, index) => normalizeSourceLink(link, index, item));
    }
    const inactiveFallback = inactiveFallbackSourceLink(item);
    return inactiveFallback ? [inactiveFallback] : [];
  }

  const relatedLinks = Array.isArray(item.relatedSourceListings)
    ? item.relatedSourceListings
    : [];
  const links = relatedLinks
    .filter(link => link?.sourceUrl)
    .map((link, index) => normalizeSourceLink(link, index, item));
  if (links.length) return links;
  if (!item.sourceUrl) return [];
  const inactiveFallback = inactiveFallbackSourceLink(item);
  if (inactiveFallback) return [inactiveFallback];
  return [
    {
      key: 'sourceUrl',
      label: 'Abrir',
      icon: 'i-lucide-external-link',
      url: item.sourceUrl,
      root: rootUrl(item.sourceUrl),
      inactive: false,
      title: 'Abrir anúncio no concorrente',
    },
  ];
}

export function hasSourceLinks(item) {
  return Boolean(item?.sourceLinksTotalCount || itemSourceLinks(item).length);
}

export function visibleSourceLinks(item) {
  if (
    Array.isArray(item?.sourceLinksVisible) &&
    item.sourceLinksVisible.length
  ) {
    return item.sourceLinksVisible
      .filter(link => link?.url || link?.sourceUrl)
      .map((link, index) => normalizeSourceLink(link, index, item));
  }
  return itemSourceLinks(item).slice(0, 1);
}

export function hiddenSourceLinksCount(item) {
  const count = Number(item?.sourceLinksHiddenCount);
  if (Number.isFinite(count)) return Math.max(count, 0);
  return Math.max(itemSourceLinks(item).length - 1, 0);
}
